export function clearAtlasExterior(data: Uint8ClampedArray, width: number, height: number) {
  const visited = new Uint8Array(width * height);
  const queue = new Int32Array(width * height);
  let read = 0, write = 0;
  const add = (index: number) => {
    if (visited[index]) return;
    visited[index] = 1;
    const p = index * 4;
    const lo = Math.min(data[p], data[p + 1], data[p + 2]);
    const hi = Math.max(data[p], data[p + 1], data[p + 2]);
    if (lo >= 230 && hi - lo <= 25) queue[write++] = index;
  };
  for (let x = 0; x < width; x++) { add(x); add((height - 1) * width + x); }
  for (let y = 0; y < height; y++) { add(y * width); add(y * width + width - 1); }
  while (read < write) {
    const index = queue[read++];
    data[index * 4 + 3] = 0;
    if (index % width > 0) add(index - 1);
    if (index % width < width - 1) add(index + 1);
    if (index >= width) add(index - width);
    if (index < width * (height - 1)) add(index + width);
  }
}
